import React, { useRef } from "react";
import "./heroSection.css";
import { motion, useScroll, useTransform } from "framer-motion";

const HeroSection = () => {
  const ref = useRef(null);

  const { scrollYProgress } = useScroll({
    target: ref,

    offset: ["start start", "end start"],
  });

  const xCrea = useTransform(scrollYProgress, [0, 1], ["0%", "-100vw"]);
  const xDev = useTransform(scrollYProgress, [0, 1], ["0%", "100vw"]);
  const opacity = useTransform(scrollYProgress, [0, 0.1], [1, 0]);

  return (
    <section className="hero-container" ref={ref}>
      <div className="hero">
        <div className="heroTop">
          <motion.div className="Description_sp" style={{ opacity, x: xCrea }}>
            <p>Available for</p>
            <p>work-study</p>
            <p>program offering</p>
            <p>exciting projects</p>
          </motion.div>
          <motion.span className="Crea_sp" style={{ x: xCrea }}>
            Creative
          </motion.span>
        </div>
        <motion.span className="Dev_sp" style={{ x: xDev }}>
          Developer
        </motion.span>
      </div>
    </section>
  );
};

export default HeroSection;
